import api from '../../apiConfig/apiConfig';
import { Get, Post } from '../base/baseAjax';

function getMonitorId(params) {
	return Post({
		url: api.websiteMonitor.getMonitorId,
		UrlParam: params,
	});
}

function getMonitorResults(params) {
	return Get({
		url: api.websiteMonitor.getMonitorResults,
		PathParam: params,
	});
}

function getMonitorMyResults(params) {
	return Get({
		url: api.websiteMonitor.getMonitorMyResults,
		UrlParam: params,
	});
}

function getAliMonitor() {
	return Post({
		url: api.websiteMonitor.getAliMonitor,
	});
}

function siteTestToolCountry() {
	return Get({
		url: api.websiteMonitor.siteTestToolCountry,
	});
}

export default {
	getMonitorId,
	getMonitorResults,
	getMonitorMyResults,
	getAliMonitor,
	siteTestToolCountry,
};
